import React, { useState, useRef } from 'react';
import useStyles from './useStyles';
import sharedStyles from '../ChatBox/useStyles';
import PropTypes from 'prop-types';
import {
  TextField,
  IconButton,
  InputAdornment,
  ClickAwayListener,
  Popper,
  Chip
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import SearchIcon from '@mui/icons-material/Search';

function CandidateFilter({
  conversations,
  statuses,
  selectedStatuses,
  setSelectedStatuses,
  searchTerm,
  setSearchTerm
}) {
  const [isOpen, setIsOpen] = useState(false);
  const anchor = useRef(null);

  const classes = useStyles();
  const sharedClasses = sharedStyles();

  const unselectedStatuses = statuses
    .filter((status) => conversations.map((app) => app.candidate_status).includes(status.id))
    .filter((status) => !selectedStatuses.map((selected) => selected.id).includes(status.id));

  return (
    <div className={`${classes.root} ${selectedStatuses.length > 0 ? classes.reducePadding : ''}`}>
      <div className={classes.searchContainer}>
        <TextField
          classes={{ root: classes.search }}
          variant="outlined"
          placeholder="Search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            )
          }}
        />
        <ClickAwayListener onClickAway={() => setIsOpen(false)}>
          <div>
            <IconButton
              ref={anchor}
              onClick={() => setIsOpen(!isOpen)}
              className={`${classes.filterIcon} ${isOpen ? classes.filterIconActive : ''}`}
            >
              <FilterListIcon />
            </IconButton>
            <Popper
              className={`${sharedClasses.popper} ${classes.popperStatuses}`}
              anchorEl={anchor.current}
              open={isOpen}
              placement="bottom-end"
              popperOptions={{ positionFixed: true }}
            >
              {unselectedStatuses.length > 0 ? (
                unselectedStatuses.map((status) => (
                  <div
                    key={status.id}
                    className={sharedClasses.popperItem}
                    onClick={() => {
                      setSelectedStatuses([...selectedStatuses, status]);
                      setIsOpen(false);
                    }}
                  >
                    {status.name}
                  </div>
                ))
              ) : (
                <div className={classes.chipNoItems}>No statuses to display</div>
              )}
            </Popper>
          </div>
        </ClickAwayListener>
      </div>
      {selectedStatuses.length > 0 && (
        <div className={classes.chipContainer}>
          {selectedStatuses.map((status) => (
            <Chip
              key={status.id}
              className={classes.chipItem}
              label={status.name}
              onDelete={() =>
                setSelectedStatuses(
                  selectedStatuses.filter((selected) => selected.id !== status.id)
                )
              }
              variant="outlined"
            />
          ))}
        </div>
      )}
    </div>
  );
}

CandidateFilter.propTypes = {
  conversations: PropTypes.array.isRequired,
  statuses: PropTypes.arrayOf(
    PropTypes.shape({
      colour: PropTypes.string,
      id: PropTypes.number,
      name: PropTypes.string,
      position: PropTypes.number,
      state: PropTypes.string
    })
  ).isRequired,
  selectedStatuses: PropTypes.array.isRequired,
  setSelectedStatuses: PropTypes.func.isRequired,
  searchTerm: PropTypes.string,
  setSearchTerm: PropTypes.func.isRequired
};

export default CandidateFilter;
